export default __webpack_public_path__ + "static/media/h-design.ce2673ba.webp";